export default "__VITE_ASSET__O0tfj8HK__"